var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"started-layout bs-flex bs-column"},[(_vm.showHeader)?_c('common-started-header'):_vm._e(),_c('div',{staticClass:"content bs-flex-1"},[_vm._t("default")],2),_c('common-started-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }